
















































































import { Component, Mixins, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { OptionalVariableData, OptionalVariableSelect, EventBus, TypeEventBus } from '../utils';
import { AuthStoreHelper, RootStoreHelper, VehicleStoreHelper } from '../../core/mixins';

@Component
export default class VariableList extends Mixins(RootStoreHelper, VehicleStoreHelper, AuthStoreHelper) {
    @Prop({ default: null }) variables: OptionalVariableData;
    @Prop() selectedVariable: OptionalVariableSelect | null;
    @Prop() setSecondaryVariable: OptionalVariableSelect | null;
    @Prop() varToOverlap: OptionalVariableSelect | null;
    @Prop({ default: false }) shouldDisplayPlusButtons: boolean;
    @Prop() mapHeight: number;
    disablePlusButton: boolean = false;
    clickedButton: boolean = false;
    seeHeaders: boolean = false;
    activeVariable: string | null = null;
    offsetTop: number = 0;
    tooltipMsgAdd = 'Añadir variable a gráfica actual';
    tooltipMsgRemove = 'Quitar variable de la gráfica actual';

    onScroll(e) {
        this.offsetTop = e.target.scrollTop;
    }

    mounted() {
        this.selectVariable(this.variablesList[0]);

        EventBus.$on(TypeEventBus.ENABLE_PLUS_BUTTON, () => {
            this.disablePlusButton = false;
        });
    }

    updateHeadersSwitch(){
        if(!this.seeHeaders && this.checkIfVariableIsHeader(this.selectedVariable)){
            this.resetVariableList();
        }

        if(!this.seeHeaders && this.checkIfVariableIsHeader(this.setSecondaryVariable)){
            this.removeSecondaryVariable();
        }
    }

    checkIfVariableIsHeader(variable){
        if(variable && variable['id'] < 0){
            return true
        }
        return false
    }

    @Watch('$_getFilterDate')
    @Watch('$_getSelectedVehiclesByID')
    @Watch('$_getDateRange')
    observableFilterDate() {
        this.removeOverlapVariable();
    }

    @Watch('setSecondaryVariable', { immediate: true, deep: true })
    changeSecondaryVariable(value) {
        for (let i = 0; i < this.variablesList.length; i++) {
            if (this.variablesList[i] === value) {
                this.activeVariable = this.variablesList[i]['description'];
            }
        }
    }

    get visibleVariables(){
        let allVariables = this.variablesList;
        let vars = allVariables;
        if(!this.seeHeaders){
            //muestro las variables que no son encabezado
            let filteredVars:Array<object> = [];
            this.variablesList.forEach(function(option) {
                if (!option['is_header']) {
                    filteredVars.push(option);
                }
            });
            vars = filteredVars;
        }
        return vars
    }

    get getDisablePlusButton() {
        return this.disablePlusButton;
    }

    get variablesList() {
        if (this.variables !== null) {
            let obj: any = this.variables;
            obj = obj.sort((x: any, y: any) => x.description.localeCompare(y.description));

            return obj;
        } else {
            return [];
        }
    }

    plusButtonClicked(index, selectedVariable, variable) {
        // clickBehaviour(selectedVariable, variable, clickedButton != clickedButton)
        this.disablePlusButton = true;
        if (this.activeVariable !== variable['description']) {
            this.activeVariable = variable['description'];
        } else {
            this.activeVariable = null;
        }

        let action = variable['description'] === this.activeVariable ? true : false;
        this.$emit('plus-button-clicked', selectedVariable, variable, action);
    }

    removeOverlapVariable() {
        this.activeVariable = null;
    }

    @Emit()
    selectVariable(variable) {
        return variable;
    }

    @Emit()
    resetVariableList() {}
    
    @Emit()
    removeSecondaryVariable() {}
}
